<template>
  <v-dialog
    :content-class="'assets-list-right'"
    :value="internalValue"
    :width="width"
    :hide-overlay='true'
    transition="slide-x-reverse-transition"
    @click:outside='onCloseClickButton'
    @keydown.esc="onCloseClickButton"
  >
    <div class='assets-list-popup'>
      <div class='assets-list-popup__action'>
      <span class='close_btn' @click='onCloseClickButton'>
        <span class="material-icons-outlined">
          close
        </span>
      </span>
      </div>
      <div class='assets-list-popup__content'>
        <div class='assets-list-popup__content__title'>
          <span class='assets-list-popup__content__title__icon'>
            <v-img v-if="technologyIcon" :src='technologyIcon'/>
            <span v-else class="material-icons-outlined widgets">
              widgets
            </span>
          </span>
          <span class='assets-list-popup__content__title__name'>
            {{ formattedNameAndVersion }}
          </span>
          <div class='assets-list-popup__content__title__actions'>
            <span class='assets-list-popup__content__title__actions__copy'>
              <custom-tooltip placement="bottom" popper-class="light-tooltip">
                <div slot='buttonContent'>
                  <v-btn icon class="copy-btn" target="_blank" @click='copyDomainList' :ripple="false">
                    <v-icon>content_copy</v-icon>
                  </v-btn>
                </div>
                <div slot="content">
                  <slot name="tooltip">
                    {{$t('technologies.right.popup.copy.title')}}
                  </slot>
                </div>
              </custom-tooltip>
            </span>
            <span class='assets-list-popup__content__title__actions__export'>
              <custom-tooltip placement="bottom" popper-class="light-tooltip">
                <div slot='buttonContent'>
                  <v-btn icon class="export-btn" target="_blank" @click='exportDomainList' :ripple="false">
                    <v-icon>file_download</v-icon>
                  </v-btn>
                </div>
                <div slot="content">
                  <slot name="tooltip">
                    {{$t('technologies.right.popup.export.title')}}
                  </slot>
                </div>
              </custom-tooltip>
            </span>
          </div>
        </div>
        <div class='assets-list-popup__content__description' :id="`${technologyItem.id}`">
          <div class='assets-list-popup__content__description__row'
               v-for='(subdomain, index) in subdomainsList' :key='index'>
            <span class='subdomain'> {{ subdomain }} </span>
            <span class='versions' v-if='assetsAndVersions[subdomain].length && assetsAndVersions[subdomain][0] !== "N/A"'>
              <v-chip-group :show-arrows='true'>
                <v-chip x-small
                        label
                        outlined
                        v-for="(version, index) in assetsAndVersions[subdomain]"
                        :key="`${version}-${index}`"
                        text-color="black"
                        class='chip'
                >
                  {{version}}
                </v-chip>
              </v-chip-group>
            </span>
          </div>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import technologiesKeys from '@/constants/technologies';
import indexDB from '@/assets/tech-metadata/index-db.json';
import CustomTooltip from '@/components/common/CustomTooltip.vue';
import disableOuterScrollOnPopupVisible from '@/mixins/disableOuterScrollOnPopupVisible';

export default {
  name: 'AssetsListRightPopup',
  components: {CustomTooltip},
  mixins: [disableOuterScrollOnPopupVisible],
  props: {
    technologyItem: {
      type: Object,
      required: true,
    },
    internalValue: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    assetsAndVersions() {
      const assetsAndVersions = {};
      if (this.technologyItem?.assets) {
        const versions = Object.keys(this.technologyItem.assets);
        for (let i = 0; i < versions.length; i += 1) {
          const currentVersion = versions[i];
          for (let j = 0; j < this.technologyItem.assets[currentVersion].length; j += 1) {
            const currentSubdomain = this.technologyItem.assets[currentVersion][j];
            if (Object.keys(assetsAndVersions).includes(currentSubdomain)) {
              const currentVersionsValue = assetsAndVersions[currentSubdomain];
              currentVersionsValue.push(currentVersion);
              assetsAndVersions[currentSubdomain] = currentVersionsValue;
            } else {
              assetsAndVersions[currentSubdomain] = [currentVersion];
            }
          }
        }
      }
      return assetsAndVersions;
    },
    subdomainsList() {
      return Object.keys(this.assetsAndVersions);
    },
    width() {
      return 428;
    },
    formattedNameAndVersion() {
      return this.technologyItem.name?.replace('/', ' ') || 'N/A';
    },
    technologyFormattedName() {
      const techName = this.technologyItem.name?.split('/')[0];
      const formattedTechName = techName.toLowerCase().replaceAll(' ', '-').replace('.', '');
      if (Object.keys(indexDB).includes(formattedTechName)) {
        if (Object.keys(indexDB[formattedTechName]).includes(technologiesKeys.ref)) {
          return indexDB[formattedTechName][technologiesKeys.ref];
        }
      }
      return formattedTechName;
    },
    technologyIcon() {
      let iconSearch;
      let searchName = this.technologyFormattedName;
      let icon;
      if (this.technologyItem.name) {
        if (Object.keys(indexDB).includes(this.technologyFormattedName)) {
          if (Object.keys(indexDB[this.technologyFormattedName]).includes(technologiesKeys.ref)) {
            searchName = indexDB[this.technologyFormattedName][technologiesKeys.ref];
          }
          iconSearch = indexDB[searchName][technologiesKeys.icon];
        }
        try {
          // eslint-disable-next-line global-require,import/no-dynamic-require
          icon = require(`@/assets/tech-metadata/${iconSearch}`);
        } catch (e) {
          icon = null;
        }
      }
      return icon;
    },
    assetsListForCopy() {
      let text = '';
      this.subdomainsList.forEach(subdomain => {
        text += `${subdomain} \n`;
      });
      return text;
    },
  },
  methods: {
    onCloseClickButton() {
      this.$emit('closed');
    },
    copyDomainList() {
      const r = document.createRange();
      r.selectNode(document.getElementById(this.technologyItem.id));
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(r);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();
    },
    exportDomainList() {
      const dataStream = this.assetsListForCopy;
      const blob = new Blob([dataStream], { type: 'text/plain' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute('download', `subdomains-for-${this.technologyFormattedName}.txt`);
      document.body.appendChild(link);
      link.click();
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.close_btn {
  margin-right: $space-1-5;
  margin-top: calc(#{$space-2} + #{$space-0-5});
  float: right;
  &:hover {
    cursor: pointer;
  }
}
.v-dialog__content {
  align-items: stretch;
  justify-content: flex-end;
}
.assets-list-popup {
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
  &__content {
    display: flex;
    flex-direction: column;
    margin-left: rem(24);
    margin-right: rem(24);
    &__title {
      margin-bottom: rem(19);
      display: flex;
      &__icon {
        .v-image {
          max-width: $space-8;
        }
        .widgets {
          max-width: $space-8;
          padding-top: $space-1-5;
        }
      }
      &__name {
        color: var(--text-primary);
        font-family: $font-family-bold;
        font-size: $space-4;
        font-weight: bold;
        letter-spacing: 0;
        margin-left: $space-2;
        text-transform: capitalize;
        align-self: center;
      }
      &__actions {
        margin-left: rem(25);
        &__copy {
          margin-right: $space-1-5;
          &:hover {
            cursor: pointer;
          }
        }
        &__export {
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
    &__description {
      color: var(--text-primary);
      font-family: $font-family-regular;
      font-size: $font-size-base;
      letter-spacing: 0;
      line-height: rem(18);
      margin-bottom: $space-8;
      display: flex;
      flex-direction: column;
      &__row {
        margin-bottom: $space-5;
        display: flex;
        align-items: center;
        .subdomain {
          flex: 80%;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        .versions {
          flex: 1;
        }
      }
    }
  }
  .export-btn {
    background-color: var(--bg-secondary);
    box-shadow: none;
    letter-spacing: 1.07px;
    line-height: $space-4;
    text-align: center;
    text-transform: uppercase;
    min-width: rem(28);
    max-width: rem(28);
    min-height: rem(28);
    max-height: rem(28);
    color: var(--text-primary);
    .v-icon {
      font-size: $space-4;
    }
    &:hover {
      cursor: pointer;
      border: $border-width-thin solid var(--brand-primary);
      background-color: var(--bg-tertiary);
    }
    &:active{
      border: $border-width-thin solid var(--brand-primary);
      background-color: var(--bg-tertiary);
    }
  }
  .copy-btn {
    background-color: var(--bg-secondary);
    box-shadow: none;
    letter-spacing: 1.07px;
    line-height: $space-4;
    text-align: center;
    text-transform: uppercase;
    min-width: rem(28);
    max-width: rem(28);
    min-height: rem(28);
    max-height: rem(28);
    color: var(--text-primary);
    .v-icon {
      font-size: $space-4;
    }
    &:hover {
      cursor: pointer;
      border: $border-width-thin solid var(--brand-primary);
      background-color: var(--bg-tertiary);
    }
    &:active{
      border: $border-width-thin solid var(--brand-primary);
      background-color: var(--bg-tertiary);
    }
  }
}
</style>
<style lang='scss'>
@import '~@/assets/styles/design-system';

.assets-list-right {
  margin: 0 !important;
  max-height: 100% !important;
  height: 100vh !important;
  position: fixed !important;
  top: 0 !important;
  right: 0 !important;
  border-radius: 0 !important;
}

.assets-list-right .assets-list-popup {
  height: 100%;
  background-color: var(--bg-primary);
}

.assets-list-right .assets-list-popup__content__description {
  overflow-y: auto;
  flex: 1;
}

.assets-list-popup {
  z-index: 5;
  .v-slide-item {
    &:hover {
      cursor: default;
      opacity: 0;
      background-color: var(--bg-primary);
    }
    &:focus::after {
      opacity: 0;
      background-color: var(--bg-primary);
    }
  }
  .theme--light.v-chip:focus::before {
    opacity: 0;
  }
  .v-chip {
    pointer-events: none;
    &:hover {
      cursor: default;
      background-color: var(--bg-primary);
    }
  }
  .v-slide-item--active {
    background-color: var(--bg-primary);
    &:focus::after {
      opacity: 0;
      background-color: var(--bg-primary);
    }
  }
  .v-chip--active {
    background: var(--bg-primary);
  }
  .v-slide-group__next, .v-slide-group__prev {
    min-width: 0px;
  }
  .v-item-group {
    max-width: rem(200);
  }
}
</style>
